module.exports = __webpack_public_path__ + "img/icon-camera.9e96bda7.svg";